/**
 * Main Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PerpetualPair } from './perpetualPair';

/**
 * Perpetual trade DTO.
 */
export interface PerpetualTradeDto {
  /**
   * Unique identifier of the trade record
   */
  id?: number;
  /**
   * Execution ID (external) from the exchange
   */
  execId?: string;
  /**
   * Associated perpetual trading pair
   */
  perpetualPair?: PerpetualPair;
  /**
   * Trade side: BUY or SELL
   */
  side?: PerpetualTradeDto.SideEnum;
  /**
   * Executed quantity
   */
  execQty?: number;
  /**
   * Executed price
   */
  execPrice?: number;
  /**
   * Fee charged for the execution
   */
  fee?: number;
  /**
   * Timestamp when the trade was transacted
   */
  transactTime?: string;
}
export namespace PerpetualTradeDto {
  export const SideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type SideEnum = (typeof SideEnum)[keyof typeof SideEnum];
}
